module.exports = __webpack_public_path__ + "img/weather59.0220b00d.png";